import Vue from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const CustomLoader = Vue.extend({
    name: 'CustomLoader',
    render(h) {
        return h('div', { class: 'spinner loading-spinner' });
    }
});

Vue.component('custom-loader', CustomLoader);

Vue.use(Loading, {
    color: '#000000',
    width: 64,
    height: 64,
    backgroundColor: '#ffffff',
    opacity: 0.5,
    zIndex: 999
}, {
    default: (new Vue()).$createElement('custom-loader')
});